import { Common, Icon } from "@/components";
import { dropdownIds } from "../configVariable";
import { dropMenuEditItem } from "../models/staticData";

interface Props {
  onSwap: () => void;
  onMove: () => void;
  onChangeDriver?: () => void;
  onBasicReoptimise?: () => void;
  onAdvancedReoptimise?: () => void;
  onReverseSequence?: () => void;
  isOptimisationEnabled?: boolean;
}

const DropdownMenu = [
  // {
  //   id: dropdownIds.MOVETR,
  //   name: "Move to other route",
  //   tooltipContent: "",
  //   icon: <Icon.MoveTo size="12" className="mr-2 fill-neutral-50" />,
  // },
  {
    id: dropdownIds.SWAP_ROUTE,
    name: "Swap route",
    tooltipContent: "",
    icon: <Icon.Switch size="12" className="mr-2 fill-neutral-50" />,
  },
  {
    id: dropdownIds.CHANGE_DRIVER,
    name: "Change driver",
    tooltipContent: "",
    icon: <Icon.Driver size="12" className="mr-2 fill-neutral-50" />,
  },
  {
    id: dropdownIds.BASIC_REOPTIMISE_ROUTE,
    name: "Basic reoptimise",
    tooltipContent: "",
    icon: <Icon.Split size="12" className="mr-2 fill-neutral-50" />,
  },
  {
    id: dropdownIds.ADVANCED_REOPTIMISE_ROUTE,
    name: "Advanced reoptimise",
    tooltipContent: "",
    icon: <Icon.Split size="12" className="mr-2 fill-neutral-50" />,
  },
  {
    id: dropdownIds.REVERSE_SEQUENCE,
    name: "Reverse delivery sequence",
    tooltipContent: "",
    icon: <Icon.Distant size="12" className="mr-2 fill-neutral-50" />,
  },
];

const DeliveryItemActionsDropdown = ({
  onSwap,
  onMove,
  onChangeDriver,
  onBasicReoptimise,
  onAdvancedReoptimise,
  onReverseSequence,
  isOptimisationEnabled,
}: Props) => {
  const handleDropdownItemClick = (item: dropMenuEditItem) => {
    switch (item.id) {
      case dropdownIds.SWAP_ROUTE:
        onSwap();
        break;
      case dropdownIds.MOVETR:
        onMove();
        break;
      case dropdownIds.CHANGE_DRIVER:
        onChangeDriver && onChangeDriver();
        break;
      case dropdownIds.BASIC_REOPTIMISE_ROUTE:
        onBasicReoptimise && onBasicReoptimise();
        break;
      case dropdownIds.ADVANCED_REOPTIMISE_ROUTE:
        onAdvancedReoptimise && onAdvancedReoptimise();
        break;
      case dropdownIds.REVERSE_SEQUENCE:
        onReverseSequence && onReverseSequence();
        break;
      default:
        break;
    }
  };

  const isReoptimiseItemVisible = (itemId: string) => {
    if (!isOptimisationEnabled) return false;

    if (itemId === dropdownIds.BASIC_REOPTIMISE_ROUTE) {
      return onBasicReoptimise !== undefined;
    }

    if (itemId === dropdownIds.ADVANCED_REOPTIMISE_ROUTE) {
      return onAdvancedReoptimise !== undefined;
    }

    return true;
  };

  return (
    <Common.DropDowns
      buttonRender={
        <div className="w-6 h-6 inline-flex items-center justify-center border font-medium group bg-white text-blue border-neutral-20 hover:border-blue-dark rounded">
          <Icon.SeeMore size="14" className="fill-blue" />
        </div>
      }
      listRender={
        <div>
          {DropdownMenu.map(
            (item) =>
              (item.id !== dropdownIds.CHANGE_DRIVER ||
                onChangeDriver !== undefined) &&
              (item.id !== dropdownIds.BASIC_REOPTIMISE_ROUTE &&
              item.id !== dropdownIds.ADVANCED_REOPTIMISE_ROUTE
                ? true
                : isReoptimiseItemVisible(item.id)) &&
              (item.id !== dropdownIds.REVERSE_SEQUENCE ||
                onReverseSequence !== undefined) && (
                <Common.DropdownItem
                  key={item.id}
                  icon={item.icon}
                  onClick={() => handleDropdownItemClick(item)}
                >
                  {item.name}
                </Common.DropdownItem>
              )
          )}
        </div>
      }
    />
  );
};

export default DeliveryItemActionsDropdown;
